import { reactive, readonly, computed } from 'vue';

const state = reactive({
    width: window.innerWidth
});

const size = computed(() => {
    if (state.width < 640) return 'xs';
    if (state.width < 768) return 'sm';
    if (state.width < 1024) return 'md';
    if (state.width < 1280) return 'lg';
    return 'xl';
});

const updateSize = () => {
    state.width = window.innerWidth;
};

window.addEventListener('resize', updateSize);

export default readonly({
    get width() {
        return state.width;
    },
    get size() {
        return size.value;
    }
});